// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609080559/js/" + chunkId + "." + {"44":"7990b0aa","225":"fb6934ce","481":"b98046a8","486":"a68deb7f","770":"cb7675d3"}[chunkId] + ".0.4184735387253339.chunk.js";
};